import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { MatiereList } from '../components'

export function MatieresListPage() {
  const { t } = useTranslation()

  return (
    <div>
      <EntityPageHeader
        title={t('administration.sections.subjects.pageTitle', 'Gestion des Matières')}
        backTo="/administration"
        createTo="/administration/matieres/create"
        createLabel={t('administration.sections.subjects.createButton', 'Créer une matière')}
      />
      <MatiereList />
    </div>
  )
}
